<template>
  <v-dialog
    v-model="show"
    persistent
    min-height="500"
    max-width="500">
    <v-card>
      <v-card-title>
        <v-flex class="font-number-2 text-xs-center">{{ dialogText }}</v-flex>
      </v-card-title>
      <v-layout row wrap align-center>
        <v-flex xs4 />
        <v-flex xs4 text-xs-center>
          <h1>{{ dialogTimer }}s</h1>
          <v-btn
            :disabled="cannotCancelAnymore"
            large
            color="error"
            @click="$emit('cancel')">
            Cancel
          </v-btn>
        </v-flex>
        <v-flex xs4 />
        <v-flex xs12>
          <br>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StreamingDialog",
  props: {
    show: {
      type: Boolean
    },
    dialogText: {
      type: String,
      default: ""
    },
    dialogTimer: {
      type: Number,
      default: 0
    },
    cannotCancelAnymore: {
      type: Boolean
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/live/StreamingDialog.vue